<template lang="pug">
  div
    StepNavigation(:active-step="activeStep" :steps="totalSteps")
    StepOne(v-if="activeStep===1")
    StepTwo(v-if="activeStep===2")
    StepThree(v-if="activeStep===3")
</template>

<script>
import StepOne from '@/components/LayoutOne/StepOne.vue';
import StepTwo from '@/components/LayoutOne/StepTwo.vue';
import StepThree from '@/components/LayoutOne/StepThree.vue';
import StepNavigation from '@/components/Common/StepNavigation.vue';
import { mapState } from 'vuex';

export default {
  name: 'LayoutOne',
  data() {
    return {
      totalSteps: [1, 2, 3],
    };
  },
  components: {
    StepOne,
    StepTwo,
    StepThree,
    StepNavigation,
  },
  computed: {
    ...mapState({
      activeStep: (state) => state.activeStep,
    }),
  },
};
</script>
